import { useState } from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/orders/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import {
  OrderCrudProvider,
  useOrderCrudContext,
} from "@/context/orderCrudContext"
import { useNavigate } from "react-router-dom"

export default function WebsiteOrderList() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Website Orders</h5>
      </div>

      <OrderCrudProvider>
        <WebsiteOrderTable />
      </OrderCrudProvider>
    </>
  )
}

function WebsiteOrderTable() {
  const { openOrderDialog, setOpenOrderDialog, setSelectedOrderRow } =
    useOrderCrudContext()

  const navigate = useNavigate()

  return (
    <>
      <CustomTable
        label="Website Orders"
        columns={columns}
        apiPath="orders/pending-website"
        onAdd={() => setOpenOrderDialog(true)}
        onView={(rowData) => {
          navigate(`/website-orders/${rowData.id}`)
        }}
        showEdit={false}
        showDelete={false}
      />

      {openOrderDialog ? <Modal /> : null}
    </>
  )
}
